export default __webpack_public_path__ + "static/media/fs-electric.032ff284.png";